__turbopack_context__.v({
  "commandPaletteContainer": "YsrTOa_commandPaletteContainer",
  "filterChip": "YsrTOa_filterChip",
  "helperText": "YsrTOa_helperText",
  "iconContainer": "YsrTOa_iconContainer",
  "input": "YsrTOa_input",
  "noResults": "YsrTOa_noResults",
  "rule": "YsrTOa_rule",
  "searching": "YsrTOa_searching",
  "submitButton": "YsrTOa_submitButton",
  "suggestion": "YsrTOa_suggestion",
  "suggestionCategoryLabel": "YsrTOa_suggestionCategoryLabel",
  "suggestionContainer": "YsrTOa_suggestionContainer",
  "wrapper": "YsrTOa_wrapper",
});
